import { render, staticRenderFns } from "./TheCategoriesList.vue?vue&type=template&id=d2e275f0&"
import script from "./TheCategoriesList.vue?vue&type=script&lang=js&"
export * from "./TheCategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./TheCategoriesList.vue?vue&type=style&index=0&id=d2e275f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports